export const HIRA_DETAIL_SOURCE_URL = "https://www.data.go.kr/data/15001699/openapi.do";
// Static registration information, not real-time acceptance or opening status.
export const HIRA_DETAIL_TTL_MS = 7 * 24 * 60 * 60_000;
export const capabilityKinds = ["specialists", "equipment", "treatments"];
export function hiraCapabilitiesView(capabilities, now) {
    const parts = capabilityKinds.map((kind) => {
        const part = capabilities?.[kind];
        const state = status(part?.fetchedAt ?? undefined, part?.failed ?? false, (part?.items.length ?? 0) > 0, now);
        return [kind, { status: state, fetchedAt: part?.fetchedAt ?? null, items: state === "CURRENT" || state === "LAST_KNOWN" ? part.items : [] }];
    });
    return Object.fromEntries(parts);
}
function status(fetchedAt, failed, populated, now) {
    if (fetchedAt === undefined)
        return failed ? "UNAVAILABLE" : "NOT_COLLECTED";
    const age = now.getTime() - Date.parse(fetchedAt);
    if (!Number.isFinite(age) || age < 0)
        return "EXPIRED";
    // This is registered directory information, not live availability. A failed
    // refresh/7-day refresh deadline must not erase the last verified values.
    if (failed || age > HIRA_DETAIL_TTL_MS)
        return "LAST_KNOWN";
    return populated ? "CURRENT" : "NOT_PROVIDED";
}
export function hiraDetailsView(facility, now) {
    const details = facility.hiraDetails;
    const departments = details?.departments;
    const hours = details?.hours;
    const departmentStatus = status(departments?.fetchedAt, details?.departmentError ?? false, (departments?.items.length ?? 0) > 0, now);
    const hoursStatus = status(hours?.fetchedAt, details?.hoursError ?? false, (hours?.data.weekly.length ?? 0) + (hours?.data.notes.length ?? 0) > 0 || hours?.data.saturdayLunch !== undefined, now);
    return {
        sourceUrl: HIRA_DETAIL_SOURCE_URL,
        departments: { status: departmentStatus, fetchedAt: departments?.fetchedAt ?? null, items: departmentStatus === "CURRENT" || departmentStatus === "LAST_KNOWN" ? departments.items : [] },
        hours: { status: hoursStatus, fetchedAt: hours?.fetchedAt ?? null, data: hoursStatus === "CURRENT" || hoursStatus === "LAST_KNOWN" ? hours.data : null },
        ...(details?.capabilities === undefined ? {} : { capabilities: hiraCapabilitiesView(details.capabilities, now) }),
    };
}
/** Preserve enrichment by exact official HIRA ID; never fuzzy-join NMC IDs. */
export function retainHiraDetails(facilities, previous) {
    const prior = new Map(previous.filter((entry) => entry.id.startsWith("hira:")).map((entry) => [entry.id, entry.hiraDetails]));
    return facilities.map((facility) => {
        const details = prior.get(facility.id);
        return details === undefined ? facility : { ...facility, hiraDetails: details };
    });
}
//# sourceMappingURL=hira-details.js.map